import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const IntegracaoSSO = ({ dispatch, history }) => {
  useEffect(() => {
    const listener = async (event) => {
      if (event.origin !== 'http://localhost:3001') {
        console.warn('Origem não autorizada:', event.origin);
        return;
      }

      const { tokenEmpresa, tokenUsuario } = event.data;

      if (!tokenEmpresa || !tokenUsuario) {
        console.warn('Tokens inválidos recebidos:', event.data);
        return;
      }

      try {
        // const response = await fetch('http://localhost:8080/api/auth/integracao-sso', {
        const response = await fetch('http://localhost:8080/api/auth/login-integracao', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tokenEmpresa, tokenUsuario }),
        });

        if (!response.ok) {
          dispatch.alert.error({
            message: 'Falha na autenticação SSO'
          });
          return;
        }

        const data = await response.json();

        if (data.acao === 'LOGIN_EXISTENTE') {
          try {
            await dispatch.authentication.ssoLogin({ cpf: data.cpf, perfil: 0 });
            history.push('/');
          } catch (err) {

            if (err && err.error_description === 'MULTI_PERFIL') {

              history.push({
                pathname: '/selectPerfil',
                state: { cpf: data.cpf },
              });
              return;
            }

            console.warn('Falha no SSO, erro não tratado:', err);
          }

        } else if (data.acao === 'REGISTRADO') {
          dispatch.alert.success({
            message: 'Registado com sucesso'
          });

        } else {
          console.warn('Ação desconhecida na resposta da integração:', data);
        }

      } catch (err) {
        console.error('Erro no fluxo SSO:', err);
        dispatch.alert.error({
          message: 'Erro no fluxo SSO:'
        })
      }
    };

    window.addEventListener('message', listener);
    return () => window.removeEventListener('message', listener);
  }, [dispatch, history]);

  return (
    <div>
      <h2>Autenticando via SSO...</h2>
    </div>
  );
};


export default connect()(withRouter(IntegracaoSSO));
